import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout'
import { Injectable } from '@angular/core'
import { isTouchDevice } from 'libs/shared/utils/helpers/src/lib/device-utils'
import { Observable, combineLatest, map } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GbBreakpointService {
  constructor(private breakpointObserver: BreakpointObserver) {}

  mobileView$: Observable<boolean> = this.breakpointObserver
    .observe([Breakpoints.XSmall])
    .pipe(map((breakpoint) => breakpoint.matches))

  tabletView$: Observable<boolean> = this.breakpointObserver
    .observe([Breakpoints.Small, Breakpoints.Medium])
    .pipe(map((breakpoint) => breakpoint.matches))

  desktopView$: Observable<boolean> = combineLatest([this.mobileView$, this.tabletView$]).pipe(
    map(([mobileView, tabletView]) => !mobileView && !tabletView),
  )

  isMobileOrTabletDevice$: Observable<boolean> = this.desktopView$.pipe(
    map((desktopView) => !desktopView && isTouchDevice()),
  )
}
